export default __webpack_public_path__ + "static/media/davis.c2aef1c9.jpg";